import React from 'react'
import { getBillboardsData as billboardsData } from '../../helpers/strapi.helper';

import close from './../../UI/mobile/sidebar/Icon_Close.svg'

interface Props {
  currentBillboardSelected: string
  currentCompleteCar: string
  currentCarSelected: string
  handleSelectBillboard: (payload: string, x?: number, y?: number) => void
  billboardClickX: number
  billboardClickY: number
}

interface State {
  currentSelected: any,
  openBillboard: any
}

class Billboards extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentSelected: {},
      openBillboard: false
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
      if(this.props.currentBillboardSelected !== prevProps.currentBillboardSelected){
        var billboards: any = billboardsData()
        if(this.props.currentBillboardSelected.includes('exterior')){
          var tempBillboardName = this.props.currentBillboardSelected.replace(' exterior','')
          billboards[this.props.currentCompleteCar].exterior.forEach((billboard: any) => {
            if(billboard.title === tempBillboardName){
              this.setState({
                currentSelected: billboard
              }, () => {
                this.setState({
                  openBillboard: true
                })
              })
            }
          })
        }
        if(this.props.currentBillboardSelected.includes('interior')){
          var tempBillboardNameInterior = this.props.currentBillboardSelected.replace(' interior','')
          billboards[this.props.currentCompleteCar].interior.forEach((billboard: any) => {
            if(billboard.title === tempBillboardNameInterior){
              this.setState({
                currentSelected: billboard
              }, () => {
                this.setState({
                  openBillboard: true
                })
              })
            }
          })
        }
        if(this.props.currentBillboardSelected === ''){
          this.setState({ openBillboard: false })
        }
      }
  }

  getPopupStyle(): React.CSSProperties {
    const cardWidth = 260
    const cardHeight = 360
    const margin = 12

    let left = this.props.billboardClickX + margin
    let top = this.props.billboardClickY - cardHeight / 2

    // Clamp horizontally
    if (left + cardWidth > window.innerWidth - margin) {
      left = this.props.billboardClickX - cardWidth - margin
    }
    if (left < margin) left = margin

    // Clamp vertically
    if (top < margin) top = margin
    if (top + cardHeight > window.innerHeight - margin) {
      top = window.innerHeight - cardHeight - margin
    }

    return {
      position: 'fixed',
      left: `${left}px`,
      top: `${top}px`,
      zIndex: 9999,
    }
  }

  render(): React.ReactNode {
      return(
        this.props.currentCompleteCar.split(this.props.currentCarSelected).length > 0 ? 
        <div className={this.state.openBillboard ? 'billboard-container fade-in':'billboard-container fade-out'}>
          {this.state.currentSelected && this.state.openBillboard ?
            <div className='billboard-general' style={this.getPopupStyle()}>
              <div 
              className='close-btn-container'
              data-value={this.props.currentCarSelected} 
              data-second={(this.props.currentCompleteCar.split(this.props.currentCarSelected))[1]} 
              data-child={this.state.currentSelected.title} 
             onClick={() => {this.setState({openBillboard: false}, () => { setTimeout(() => {this.setState({currentSelected: {}}, () => {this.props.handleSelectBillboard('')})}, 10)})}}> 
                <img  id='element-umbra-analytics' data-type={"BULLET"} data-value={this.props.currentCarSelected} data-second={(this.props.currentCompleteCar.split(this.props.currentCarSelected))[1]} data-child={this.state.currentSelected.title} src={close} alt=''/>
              </div>
              <img
                src={this.state.currentSelected.image}
                alt=''
                className='preview-image'
              />
              <div className='billboard-general-title'>
                {this.state.currentSelected.title}
              </div>
              <div className='billboard-general-text'>
                {this.state.currentSelected.text}
              </div>
            </div>:null
          }
        </div>
        : <></>
      )
  }
}

export default Billboards